import { useLocation, useSearchParams } from "@/lib/router";

const useAuthRedirectPath = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const activePage = location.pathname;
  const currentQueryParams = location.search;
  const paramMode = searchParams.get("mode");

  const getRoutePath = () => {
    // /checkout requires auth. Send the user to /auth and bring them back to
    // the exact checkout URL (query params included) after they sign in.
    if (activePage === "/checkout") {
      let route = "/auth?redirect=checkout";
      if (currentQueryParams) {
        route += `&query=${encodeURIComponent(currentQueryParams.substring(1))}`;
      }
      return route;
    }

    if (activePage === "/seat-management" || activePage === "/manage-devices") {
      let route = `/login?redirect=${activePage.slice(1)}`;
      if (currentQueryParams) {
        route += `&query=${encodeURIComponent(currentQueryParams.substring(1))}`;
      }
      return route;
    }

    let route = "/login";

    // special cases
    if (activePage === "/review") {
      route += "?pricing=true";
      if (paramMode === "bf") {
        route += "&mode=bf";
      }
    } else if (activePage === "/retrain") {
      route += "?retrain=true";
    } else if (activePage === "/pricing") {
      route += "?redirect=pricing";
    } else if (activePage === "/open-next") {
      // deeplink pages send the user back to their app's login screen
      route = "/next-login?medium=app&callback=next";
    } else if (activePage === "/open-photon") {
      route = "/photon-login?medium=app&callback=photon";
    }
    // adding current query params
    if (currentQueryParams) {
      route += route.includes("?")
        ? "&" + currentQueryParams.substring(1)
        : currentQueryParams;
    }

    return route;
  };

  return { getRoutePath };
};

export default useAuthRedirectPath;
